export class ScriptConfiguration {
    public script: string;
    public forceProxyGeneration: boolean;

    constructor(script = '') {
        this.script = script;
        this.forceProxyGeneration = false;
    }
}

export class TemplateConfiguration {
    public content: string;
    public templateId: number;
}

export class ScriptingProperty {
    public name: string;
    public type: string;
    public propertiesAndFunctions?: Array<ScriptingProperty>;
    public description: Description;
    public isPrimitive: boolean;
    public assemblyName: string;
    public isFunction: boolean;
    public functionArgs: Array<FunctionArg>;

    public isCollapsed?: boolean;

    constructor() {
        this.propertiesAndFunctions = new Array<ScriptingProperty>();
        this.functionArgs = new Array<FunctionArg>();
    }
}

export class Description {
    public title: string;
    public summary: string;
}

export class FunctionArg {
    public name: string;
    public type: string;
    public description: string;
}

export enum ScriptingLanguageType {
    IronPython = 1,
    Html = 2,
    TypeScript = 3,
}

export enum HelpLink {
    RzorValidation = "https://help.sap.com/docs/SAP_CPQ/884885f05e6b4c8082254d4d9d63f19b/63497a49978945ceab59d744c3738ab0.html"
  }
